module.exports = __webpack_public_path__ + "img/allthedata.4db40d65.png";